import React from 'react';
import { UserRound, Building2 } from 'lucide-react';
import { useLabelList } from '../hooks/useLabelList';
import './ProfileInfo.css';

/**
 * ProfileInfo - 个人信息展示组件
 */
export function ProfileInfo({ profileData }) {
  const isEnterprise = !!profileData?.vipLevel && profileData.vipLevel > 0;
  const { counts, isLoading, error } = useLabelList();
  const stat = value => isLoading ? '…' : error ? '—' : value;
  const row = (label, value, muted = false) => (
    <div className="profile-overview-row" key={label}>
      <span>{label}</span><strong className={muted ? 'profile-overview-muted' : undefined}>{value}</strong>
    </div>
  );

  return (
    <div className="profile-info">
      <div className="profile-overview-cards">
        <section className="profile-overview-card profile-overview-basic" aria-label="基本信息">
          <h2><UserRound size={17} aria-hidden="true" />基本信息</h2>
          <div className="profile-overview-card-body">
            {row('姓名', profileData.realName || '未填写')}
            {row('手机', profileData.phone || '未填写')}
            {row('账号类型', isEnterprise ? '企业会员' : '个人会员')}
          </div>
        </section>
        <section className="profile-overview-card" aria-label="企业信息">
          <h2><Building2 size={17} aria-hidden="true" />企业信息</h2>
          <div className="profile-overview-card-body">
            {row('企业名称', profileData.company || '未填写')}
            {row('职位', profileData.position || '未设置')}
            {row('企业资质', profileData.credentials || '暂无', !profileData.credentials)}
          </div>
        </section>
      </div>
      <section className="profile-overview-card profile-overview-statistics" aria-label="数据统计">
        <h2>数据统计</h2>
        <div className="profile-overview-stat-grid" aria-live="polite">
          <div><strong>{stat(counts.all)}</strong><span>已创建标签</span></div>
          <div><strong>{stat((counts.pending || 0) + (counts.processing || 0))}</strong><span>审核中</span></div>
          <div><strong>{stat(counts.published)}</strong><span>已发布</span></div>
        </div>
        {error && <p className="profile-overview-stat-error">统计暂时无法读取，请重新进入个人中心。</p>}
      </section>
    </div>
  );
}
